import { render, staticRenderFns } from "./synergy.vue?vue&type=template&id=11be9ce9&scoped=true"
import script from "./synergy.vue?vue&type=script&lang=ts"
export * from "./synergy.vue?vue&type=script&lang=ts"
import style0 from "./synergy.vue?vue&type=style&index=0&id=11be9ce9&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11be9ce9",
  null
  
)

export default component.exports